import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { useWolfTracsState } from '../../hooks/redux/useWolfTracsState';
import { EnrollmentPackageId, RelationshipTypeId } from '../../types/api/primaryKeys/PrimaryKey';
import { Nullable } from '../../types/custom/Nullable';
import { ReactFC } from '../../types/react/ReactFC';
import { RelationshipType } from '../../types/enums/RelationshipType';
import { addEmployeeDependent } from '../../apiCalls/employees/employeeApiCalls';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {
    // @ts-expect-error Don't have time to get types for this
    formatDate,
    // @ts-expect-error Don't have time to get types for this
    parseDate
} from 'react-day-picker/moment';

interface Props {
    packageId: EnrollmentPackageId;
}

interface FormInputs {
    relationshipTypeId: RelationshipTypeId;
    nameFirst: string;
    nameMiddle: Nullable<string>;
    nameLast: string;
    gender: string;
    usSocialSecurityNumber: Nullable<string>;
}

export const EmployeeDependentSpouseNewAdd: ReactFC<Props> = ({ packageId }) => {
    const { data: activePackage } = useWolfTracsState(s => s.packages.activePackage);
    const history = useHistory();

    const [ birthday, setBirthday ] = useState<Nullable<Date>>(null);

    const { register, handleSubmit } = useForm<FormInputs>();

    const onCancel = () => {
        history.goBack();
    };


    const onSubmit = async (form: FormInputs) => {
        // This should be "impossible"
        if (!activePackage) {
            return;
        }

        if (birthday === null) {
            alert('Date of birth is required.');
            return;
        }

        const data = {
            ...form,
            dateOfBirth: birthday.toISOString()
        };

        await addEmployeeDependent(activePackage.groupId, activePackage.personId, data);

        history.goBack();
    };

    return (
        <Card>
            <Card.Body>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group controlId="relationship-type">
                        <Form.Label>Relationship Type*</Form.Label>
                        <Form.Control required as="select" {...register('relationshipTypeId', { required: true, valueAsNumber: true })}>
                            <option value={RelationshipType.Spouse}>Spouse</option>
                            <option value={RelationshipType.DomesticPartner}>Domestic Partner</option>
                        </Form.Control>
                    </Form.Group>

                    <Form.Group controlId="birthday">
                        <Form.Label>Date of Birth*</Form.Label>
                        <div>
                            <DayPickerInput
                                inputProps={{
                                    className: 'form-control',
                                    required: true
                                }}
                                format={'MM/DD/YYYY'}
                                formatDate={formatDate}
                                parseDate={parseDate}
                                placeholder={"MM/DD/YYYY"}
                                onDayChange={date => setBirthday(date)}
                            />
                        </div>
                    </Form.Group>


                    <Form.Group controlId="first-name">
                        <Form.Label>First/Given Name*</Form.Label>
                        <Form.Control required type="text" {...register('nameFirst', { required: true })} />
                    </Form.Group>

                    <Form.Group controlId="middle-name">
                        <Form.Label>Middle Name (if any)</Form.Label>
                        <Form.Control type="text"  {...register('nameMiddle', { required: false })}/>
                    </Form.Group>

                    <Form.Group controlId="last-name">
                        <Form.Label>Last/Family Name*</Form.Label>
                        <Form.Control required type="text"  {...register('nameLast', { required: true })}/>
                    </Form.Group>

                    <Form.Group controlId="social-security-number">
                        <Form.Label>U.S. Social Security Number</Form.Label>
                        <Form.Control type="text" {...register('usSocialSecurityNumber')}></Form.Control>
                    </Form.Group>

                    <Form.Group controlId="gender">
                        <Form.Label>Your spouse&apos;s / domestic partner&apos;s sex* is</Form.Label>
                        <Form.Text muted>* The GTFF and the University of Oregon strive to welcome all members of our community, including those who do not identify as either Female or Male.</Form.Text>
                        <Form.Text muted>Our community profoundly laments that Oregon law compels us to require this question and to accept only &quot;Female&quot; or &quot;Male&quot; as valid responses.</Form.Text>
                        <Form.Control required as="select" {...register('gender', { required: true })}>
                            <option value="M">Male</option>
                            <option value="F">Female</option>
                        </Form.Control>
                    </Form.Group>

                    <div className="float-right">
                        <Button disabled={activePackage === null} type="button" className="btn-default mr-2" onClick={onCancel}>Cancel</Button>
                        <Button disabled={activePackage === null} type="submit" className="float-right">Submit</Button>
                    </div>
                </Form>
            </Card.Body>
        </Card>
    );
};